<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixinV2';
import createjsMixin from '../../mixins/createjsMixinV2';
export default {
  name: 'mp-clock-v2',
  mixins: [defaultMixins, createjsMixin],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
      moved: 0,
      moved2: 0,
      ticker: false,
      animation: false,
      movesTo: [],
      targets: [],
      corrects: [],
      clones: [],
      maxClone: 0,
      cont: false,
      min: false,
      hr: false,
    };
  },
  beforeMount() {
    this.prototypeArray();
  },
  mounted() {
    this.ticker = createjs.Ticker;
    this.setDataGame();
    this.initGame();
    this.images.forEach(function (gr, i) {
      gr.forEach(function (item) {
        if (item.tip == 'hr') item.aid = 0;
        if (item.tipStart !== undefined) {
          item.rotation = item.tipStart;
        }
      });
    });
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    stageMouseDown(e) {
      if (!this.mousedown) {
        this.resetCheckStatus();
        var grx = -1;
        var ix = -1;
        this.images.forEach(function (gr, i) {
          gr.forEach(function (cont, j) {
            if (e.target.id == cont.id) {
              ix = j;
              grx = i;
            }
          });
        });
        if (ix >= 0 && grx >= 0 && !this.images[grx][ix].block) {
          this.moved = this.images[grx][ix];
          if (ix == 0) this.moved2 = this.images[grx][1];
          else this.moved2 = this.images[grx][0];
          if (this.moved.tip == 'hr') this.moved2.rotation = -90;
          this.stage.on('stagemousemove', this.stageMouseMove);
          this.mousedown = true;
        }
      }
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        let gp = this.moved.localToGlobal(0, 0);
        let pt = { x: gp.x - this.offset.x, y: gp.y - this.offset.y };
        let aid = Math.atan2(e.stageY - this.offset.y - pt.y, e.stageX - this.offset.x - pt.x) * (180 / Math.PI);
        let tmp = Math.abs(aid);
        let tmp1 = Math.abs(this.moved.rotation);
        this.moved.rotation = aid;
        if (this.moved.tip == 'min') {
          if ((aid < 0 && tmp - tmp1 < 0) || (aid > 0 && tmp - tmp1 > 0)) {
            this.moved2.rotation += (Math.abs(tmp - tmp1) / 360) * 30;
          } else {
            this.moved2.rotation -= (Math.abs(tmp - tmp1) / 360) * 30;
          }
          if (this.moved2.rotation == 0) {
            this.moved2.aid = 0;
          } else {
            // NOTE: zmiana mechanizmu
            // this.moved2.aid = Math.round(this.moved2.rotation / 30) * 30;
            this.moved2.aid = Math.floor(this.moved2.rotation / 30) * 30;
          }
          if (Math.round(this.moved.rotation / 30) * 30 == -90) {
            this.moved2.rotation = Math.round(this.moved2.rotation / 30) * 30;
          }
        } else {
          this.moved2.rotation = -90;
        }
        // NOTE: zmiana mechanizmu
        if (this.moved2.rotation % 360 > 180) {
          this.moved2.rotation = (this.moved2.rotation % 360) - 360;
        } else if (this.moved2.rotation % 360 === -180) {
          this.moved2.rotation = Math.abs(this.moved2.rotation % 360);
        } else {
          this.moved2.rotation = this.moved2.rotation % 360;
        }
      }
    },
    stageMouseUp(e) {
      this.mousedown = false;
      if (this.moved.tip == 'min') {
        this.moved.rotation = Math.round(this.moved.rotation / 30) * 30;
        if (this.moved.rotation == -90) {
          this.moved2.rotation = Math.round(this.moved2.rotation / 30) * 30;
        }
        // NOTE: zmiana mechanizmu
        /** 15 min and 45 min problem (+180 and -180 +0 and -0) is the same */
        if (this.moved.rotation === 180 || this.moved.rotation === -180) {
          this.moved.rotation = Math.abs(this.moved.rotation);
        }
        this.moved2.aid = Math.round(this.moved2.aid);
        // console.log('1 min: ' + this.moved.rotation + ' hr: ' + this.moved2.aid);
      } else {
        this.moved.aid = Math.round(this.moved.rotation / 30) * 30;
        this.moved.rotation = Math.round(this.moved.rotation / 30) * 30;
      }
    },
    checkGameAction() {
      // console.log('CHECK');
      var isCorrect = true,
        self = this;
      this.images.forEach(function (gr, i) {
        var corrTip = 0;
        gr.forEach(function (bmp, j) {
          if (bmp.type == 'source') {
            if (bmp.tip == 'min') {
              if (
                bmp.rotation != self.images[bmp.target.gr][bmp.target.indx].corrTips.min &&
                bmp.rotation != self.images[bmp.target.gr][bmp.target.indx].corrTips.min - 360 &&
                bmp.rotation != self.images[bmp.target.gr][bmp.target.indx].corrTips.min + 360
              ) {
                isCorrect = false;
              } else {
                corrTip++;
              }
            } else {
              // NOTE: zmiana mechanizmu
              //   // console.log('AID: ' + bmp.aid);
              //   // console.log(bmp.rotation);
              // if (bmp.aid > bmp.rotation) {
              //   bmp.aid -= 30;
              // }
              //   // console.log('AID: ' + bmp.aid);
              if (
                bmp.aid != self.images[bmp.target.gr][bmp.target.indx].corrTips.hr &&
                bmp.aid != self.images[bmp.target.gr][bmp.target.indx].corrTips.hr - 360 &&
                bmp.aid != self.images[bmp.target.gr][bmp.target.indx].corrTips.hr + 360
              ) {
                isCorrect = false;
              } else corrTip++;
            }
          }
        });
        if (self.initData.corrBlock === true && corrTip == 2) {
          gr.forEach(function (bmp, j) {
            bmp.block = true;
          });
        }
      });
      return isCorrect;
    },
    tick(e) {
      this.stage.update(e);
    },
    resetGameAction() {
      this.newGame();
      this.images.forEach(function (gr) {
        gr.forEach(function (item) {
          if (item.tip == 'hr') item.aid = 0;
          if (item.tipStart !== undefined) {
            item.rotation = item.tipStart;
          }
        });
      });
    },
    beforeDestroy() {
      this.beforeDestroy();
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
